import { type FC, memo } from 'react';

export type CloudNetworkDetailData = {
  cloudProvider: string | null;
  networkId: string | null;
  name: string | null;
  resourceName: string | null;
  state: string | null;
  region: string | null;
  ipv4CidrBlocks: string[] | null;
  ipv6CidrBlocks: string[] | null;
  peeringCount: number | null;
};

interface Props {
  firstColumnClassName?: string;
  secondColumnClassName?: string;
  tableClassName?: string;
  tableData: CloudNetworkDetailData;
}

const renderList = (values: string[] | null): string | null =>
  values && values.length > 0 ? values.join(', ') : null;

const BareCloudNetworkDetailContent: FC<Props> = (props) => {
  return (
    <table className={props.tableClassName}>
      <tbody>
        <tr>
          <td className={props.firstColumnClassName}>Cloud provider</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.cloudProvider}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Name</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.name}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Resource name</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.resourceName}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Cloud network ID</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.networkId}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>State</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.state}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Region</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.region}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>IPv4 CIDR blocks</td>
          <td className={props.secondColumnClassName}>
            {renderList(props.tableData.ipv4CidrBlocks)}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>IPv6 CIDR blocks</td>
          <td className={props.secondColumnClassName}>
            {renderList(props.tableData.ipv6CidrBlocks)}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Peerings</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.peeringCount}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export const CloudNetworkDetailContent = memo(BareCloudNetworkDetailContent);
